// store/eventServiceSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  serviceDetails: null,
  eventDetails: null,
};

const eventServiceSlice = createSlice({
  name: 'eventService',
  initialState,
  reducers: {
    setEventServiceData: (state, action) => {
      state.serviceDetails = action.payload.serviceDetails;
      state.eventDetails = action.payload.eventDetails;
    },
    clearEventServiceData: (state) => {
      state.serviceDetails = null;
      state.eventDetails = null;
    },
  },
});

export const { setEventServiceData, clearEventServiceData } = eventServiceSlice.actions;
export default eventServiceSlice.reducer;
